import { createSelector } from 'reselect';

const selectBankAccounts = (state: any) => state.bankAccounts;

export const selectBankAccountsCurrentItem = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.current);

export const selectBankAccountsListItems = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.list);

export const selectBankAccountsItemById = (itemId: any) =>
    createSelector(selectBankAccountsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectBankAccountsQueryItems = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.query);

export const selectBankAccountsCreatedItem = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.create);

export const selectBankAccountsUpdatedItem = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.update);

export const selectBankAccountsReadItem = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.read);

export const selectBankAccountsDeletedItem = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.delete);

export const selectBankAccountsSearchedItems = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.search);

export const selectBankAccountsItemsCount = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.count);

export const selectBankAccountsItemsFilter = createSelector([selectBankAccounts], (bankAccounts) => bankAccounts.filter);